import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "./commons/SignInButton/SignInButton";
import Header from "./Header";
import { UI_COLORS } from "../config";
import { useMsal } from "@azure/msal-react";
import { useAuthentication } from "../hooks/useAuthentication";
import AppManager from "./layout/AppManager";
import { useAppManager } from "../hooks/useAppManager";
import LoginCard from "./layout/LoginCard";

/**
 * Main layout component that organizes the application structure
 * Simplified to only include authentication and header
 */
function MainLayout() {
  const { accounts } = useMsal();
  const { tenants, selectedTenant, selectTenant } = useAppManager();
  useAuthentication();

  return (
    <div
      className="flex flex-col h-screen"
      style={{ backgroundColor: UI_COLORS.background }}
    >
      <Header
        accounts={accounts}
        tenants={tenants}
        selectedTenant={selectedTenant}
        onTenantSelect={selectTenant}
      />

      {/* Main Content */}
      <main className="flex-1 w-full px-8 py-6 overflow-hidden">
        {/* Authentication Messages */}
        <UnauthenticatedTemplate>
          <LoginCard />
        </UnauthenticatedTemplate>

        {/* Main Application - Only visible when authenticated */}
        <AuthenticatedTemplate>
          <AppManager />
        </AuthenticatedTemplate>
      </main>
    </div>
  );
}

export default React.memo(MainLayout);
